import { DataSource, Image, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiProfileStatusQuickInfo extends Layout {
    labelPartnerNotes: Label;
    labelPartnerNotesImage: Label;
    linkToClassic: Image;
    panel1: Panel;
    panel2: Panel;
    panel3: Panel;
    panel4: Panel;
    panelNotes: Panel;
    sourceEdistatusProfile: DataSource;
    textboxAltPartnerId: Textbox;
    textboxFuncReceiverId: Textbox;
    textboxFuncSenderId: Textbox;
    textboxInSenderId: Textbox;
    textboxIntReceiverId: Textbox;
    textboxPartnerId: Textbox;
    textboxTemplateId: Textbox;
    textboxVersion: Textbox;
}
